import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SnackbarService } from 'src/app/shared/services/snackbar/snackbar.service';
import { WebServiceService } from 'src/app/shared/services/web/web-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hidePassword = true;
  form = new FormGroup({
    password: new FormControl('', [
      Validators.required,
    ])
  });
  isValidLink = false;
  participantId: string = '';
  parentId: string = '';
  constructor(
    public authService: AuthService,
    private route: ActivatedRoute,
    private webService: WebServiceService,
    private router: Router,
    private snackbarService: SnackbarService,
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.authService.isLoggedIn) {
      await this.authService.SignOut(true);
    }
    this.route.queryParams
      .subscribe(params => {
        this.participantId = params['participantId'];
        this.parentId = params['parentId'];

        if (!this.parentId || this.parentId == "undefined") {
          this.isValidLink = false;
          return;
        }

        if (!this.participantId || this.participantId == "undefined") {
          this.isValidLink = false;
          return;
        }
        this.isValidLink = true;
      }
      );
  }

  async signIn(password: string) {
    await this.authService.signInAnonym('', '', '');
    await this.webService.refreshToken();
    const userId = this.authService.getUserId();
    this.webService.verifyParent(userId, this.participantId, this.parentId, password).subscribe({
      next: (result: any) => {
        if (result.status == 200) {
          // Fetch groups after verifyParent assigns 'parent' role, then navigate
          this.webService.getUserGroups().subscribe({
            next: (groups: any) => {
              localStorage.setItem('groups', JSON.stringify(groups.data));
              this.authService.groups$.next(groups.data);
              this.router.navigate(['/parent']);
            },
            error: () => this.router.navigate(['/parent']),
          });
          return;
        }
        window.alert('something went wrong: ' + result.message);
      },
      error: (error: any) => {
        if (error.status == 403) {
          this.snackbarService.sendErrorToUser($localize`Wrong Password or URL! Check Link and Password from Email`);
          return;
        }
        if (error.status == 429) {
          this.snackbarService.sendErrorToUser($localize`Too many failed attempts. Please try again in 15 minutes.`);
          return;
        }
        window.alert('something went wrong: ' + error.message);
      }
    });
  }
}
